import { createVuetify } from "vuetify"
import colors from 'vuetify/lib/util/colors.mjs'
import '@/assets/main.scss'
import VueApexCharts from "vue3-apexcharts"
// import VCalendar from 'v-calendar'
// import 'v-calendar/style.css'

let vuetify = null

export default defineNuxtPlugin((app) => {
  if (vuetify) return
  vuetify = createVuetify({
    ssr: false,
    theme: {
      defaultTheme: 'customTheme',
      themes: {
        customTheme: {
          dark: false,
          colors: {
            primary: colors.deepPurple.lighten2,// "#EC6D8C", // Colore di base
            secondary: colors.deepPurple.lighten3 , // "#F4A6B8", // Tonalità più chiara del primario
            accent: "#FFDCE3", // Ancora più chiaro per elementi di enfasi
            error: "#D32F2F", // Rosso intenso per errori
            info: colors.deepPurple.darken4, // Blu per informazioni
            success: colors.lightGreen.darken4, // "#4CAF50", // Verde per successo
            warning: colors.red.accent2 // "#FF9800", // Arancione per avvisi
          }
        },
      },
      // add color variations
        variations: {
          colors: ["primary", "secondary"],
          lighten: 3,
          darken: 3,
        },
    },
    defaults: {
      global: {
        elevation: 0,
        // rounded: 0,
      },
      VDialog: {
        maxWidth: '800',
      },
      VFileInput: {
        prependIcon: '',
        prependInnerIcon: 'mdi-attachment',
        density: 'compact'
      },
      VSelect: {
        density: 'compact'
      },
      VBtn: {
        elevation: 0,
        variant: 'flat',
        // ripple: 0
      },
      VTextField: {
        autocomplete: 'off',
        density: 'compact',
        clearable: true
      },
      VComboBox: {
        autocomplete: 'off',
        density: 'compact',
        clearable: true
      },
      VAutocomplete :{
        VChip: {
          closable: true,
          closeIcon: "mdi-close-circle",
        },
        autocomplete: 'off',
        density: 'compact',
        clearable: true
      },
      VAlert: {
        border: 'start',
        type: 'warning',
        variant: 'tonal',
        rounded: 0
      },
      VSwitch: {
        density: 'compact',
        inset: true,
        color: 'indigo'
      },
      VSelect: { 
        density: 'compact'
      },
      VDataTableServer: {
        density: 'compact',
      },
      VDataTableRow: {
        density: 'compact'
      },
      VDataTableItem: {
        density: 'compact'
      }
    },
    // Add the custom iconset
    icons: {
      defaultSet: "custom",
      aliases,
      sets: {
        custom,
      },
    },
  })

  // app.vueApp.use(VCalendar)
  app.vueApp.use(vuetify)
  app.vueApp.use(VueApexCharts)
})
